// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pf_a bhc_wv bhc_iz bhc_xj bhc_i bhc_j bhc_q bhc_vr bhc_er bhc_sm bhc_sn bhc_eb","ReplyButton__icon":"pf_b bhc_rx"};